import React from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import { Columns, Column, Button } from '@resurs/midas-react'
import { Conditional } from '@resurs/react-utils'
import { getText } from '../../../../../internal/TextLabels'
import styles from './styles.module.scss'

const InvoiceDoneContent = ({
  paymentDetails,
  fetchInvoice,
  showPrintButton,
}) => (
  <Columns>
    <Column col12>
      <div style={{ margin: '0 1rem' }}>
        <div style={{ margin: '0 0 1rem 0' }}>
          <div style={{ margin: '1rem 0' }}>
            {getText('payApply.invoiceDone.description1')}
            <strong>
              <NumberFormat
                value={paymentDetails.payment.paymentStatus.totalOrderAmount}
                displayType="text"
                decimalSeparator=","
                thousandSeparator=" "
                decimalScale={2}
                fixedDecimalScale
                renderText={val => getText('default.currency', val)}
              />
            </strong>
          </div>
          <h5>{getText('payApply.invoiceDone.description2')}</h5>
          <div style={{ margin: '1rem 0' }}>
            <span>{getText('payApply.invoiceDone.description3')}</span>
            <strong>{paymentDetails.customer.email}</strong>
            <Conditional when={showPrintButton}>
              <span className={styles.buttonContainer}>
                <Button type="link" onClick={fetchInvoice}>
                  {getText('payApply.paymentDone.printCopy')}
                </Button>
              </span>
            </Conditional>
          </div>
          <div style={{ margin: '1rem 0' }}>
            {getText('payApply.invoiceDone.description4')}
          </div>
          <div style={{ margin: '1rem 0' }}>
            {getText('payApply.invoiceDone.description5')}
          </div>
          <div style={{ margin: '1.5rem 0', fontSize: '1rem' }}>
            {getText('payApply.invoiceDone.description6')}
          </div>
        </div>
      </div>
    </Column>
  </Columns>
)

InvoiceDoneContent.propTypes = {
  paymentDetails: PropTypes.object.isRequired,
  fetchInvoice: PropTypes.func.isRequired,
  showPrintButton: PropTypes.bool.isRequired,
}

export default InvoiceDoneContent
